import { styled } from '@mui/material/styles'
import { ButtonAction } from './ButtonAction.styled'

export const ButtonActionSave = styled(ButtonAction, {
  name: 'ButtonActionSave',
  slot: 'Root',
  skipSx: true,
})`
  margin-left: 10px;
`
